import type { ImageLoader } from 'next/image';

// Function to normalize source path by removing the base domain and any leading slash
const normalizeSrc = (src: string) => src.replace(/^https?:\/\/[^/]+/, '').replace(/^\/+/, '');

// Cloudflare loader with auto format and refined quality
export const cloudflareLoader: ImageLoader = ({ src, width, quality }) => {
  const defaultWidth = 512;
  const defaultQuality = 75;

  // avoid use of our loaders to optimise outside images
  // This won't break non 24-social.com images, they just won't be optimised
  // also allows for local images to work
  if (!src.includes('24-social.com')) {
    return src;
  }

  // Add format=auto to allow Cloudflare to select the optimal image format
  const paramsString = `width=${width || defaultWidth},quality=${quality || defaultQuality},format=auto`;
  //src can be normalised once we're entirely on cloudflare
  const normalizedSrc = normalizeSrc(src);

  // Use absolute URL in development, relative path in production
  return `https://24-social.com/cdn-cgi/image/${paramsString}/${normalizedSrc}`;
};

export default cloudflareLoader;
